<template>
  <v-data-table :headers="headers" :items="data" hide-actions class="elevation-1" style="width: 100%; font-size: 12px;">
    <template v-slot:items="props">
      <td class="text-xs-left">{{ props.item.id }}</td>
      <td class="text-xs-left">{{ props.item.lastUsed }}</td>
      <td class="text-xs-left">{{ props.item.count }}</td>
    </template>
  </v-data-table>
</template>

<script>
  export default {
    data() {
      return {
        headers: [
          { text: 'Process Id', value: 'id' },
          { text: 'Date last used (UTC)', value: 'lastUsed' },
          { text: 'Usage count', value: 'count' },
        ],
        data: [{
          id: 'ServiceRegistryTest:27:c9b1505a-cf68-11e9-9978-0242ac150004',
          lastUsed: '2019-09-04T16:42:26',
          count: '33',
        },
        {
          id: 'DefinitionName:27:c9b1505a-cf68-11e9-9978-0242ac150004',
          lastUsed: '2019-09-04T16:42:26',
          count: '20',
        },
        ],
      }
    },
  }
</script>